// src/services/api.ts
import { type } from "arktype";
import { Room, RoomMeta } from "../../types"; // Assuming types are in src/types.ts

/**
 * Fetches the list of top rooms.
 */
export async function fetchTopRooms(): Promise<Room[]> {
  const response = await fetch("/api/rooms/top");
  if (!response.ok) {
    throw new Error("Failed to fetch top rooms");
  }
  const data = await response.json();
  const validator = Room.array();
  const out = validator(data);
  if (out instanceof type.errors) {
    console.error("Invalid top rooms data:", out.summary);
    throw new Error("Invalid top rooms data received from server.");
  }
  return out;
}

/**
 * Fetches metadata for a specific room.
 */
export async function fetchRoomMeta(roomId: string): Promise<RoomMeta> {
  const response = await fetch(
    `/api/rooms/${encodeURIComponent(roomId)}/metadata`
  );
  if (!response.ok) {
    const errorText = await response.text().catch(() => "Unknown error");
    throw new Error(
      `Failed to fetch room metadata (status: ${response.status}): ${errorText}`
    );
  }
  const data = await response.json();
  const validator = RoomMeta;
  const out = validator(data);
  if (out instanceof type.errors) {
    console.error("Invalid room metadata:", out.summary);
    throw new Error("Invalid room metadata received from server.");
  }
  return out;
}
